
const siteHeader = document.querySelector('header');
const mainContainer = document.querySelector('.main-content');

function detectWindowSizeChangeAndHeadingHeight() {

	const siteHeaderHeight = siteHeader.getBoundingClientRect().height;

	if (window.innerWidth < 1199) {
		mainContainer.style.paddingTop = siteHeaderHeight + "px";
	} else {
		mainContainer.style.paddingTop = 0;
	}
}

function inititializeDynamicPaddingForMainContent() {

	window.addEventListener("resize", (event) => {
		detectWindowSizeChangeAndHeadingHeight();
	})
	window.addEventListener("DOMContentLoaded", (event) => {
		detectWindowSizeChangeAndHeadingHeight();
	})
	window.addEventListener("orientationchange", (event) => {
		detectWindowSizeChangeAndHeadingHeight();
	})
}

export {
	inititializeDynamicPaddingForMainContent
}
